import type { ReactNode } from 'react';
import { Container } from 'react-bootstrap';
import Navbar from './Navbar';

interface LayoutProps {
  children: ReactNode;
}

export const Layout = ({ children }: LayoutProps) => {
  return (
    <>
      <Navbar />
      <Container fluid className="px-3">
        {children}
      </Container>
    </>
  );
};

export default Layout;
